import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import { CURRENT_ACCOUNT_DETAILS, CURRENT_USER_USERNAME } from "@Broker/@Modules/main/store/account/account-getters";
import { GET_CLIENT_ACTIVITY } from "../store/dashboard-getters";
import { LOAD_CLIENT_ACTIVITY } from "../store/dashboard-actions";
import AgentsDropdown from "@Broker/@Modules/agents/components/agents-dropdown.vue";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import ClientActivityAnchor from "@Shared/components/client-activity/client-activity-anchor.vue";
import ClientActivityLoader from "./loaders/client-activity-loader.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import { getBrokerImportReportAsCSV } from "../api/dashboard-api";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientsActivity",
  components: {
    AgentsDropdown,
    ProfileAvatar,
    ClientActivityAnchor,
    ClientActivityLoader
  },
  data() {
    return {
      loading: true,
      loadingClients: false,
      offset: 0,
      limit: 20,
      shouldFetchMore: true,
      selectedAgentUsername: ""
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_ACCOUNT_DETAILS, CURRENT_USER_USERNAME])), mapGetters("DashboardStore", [GET_CLIENT_ACTIVITY])), {}, {
    isBroker() {
      return this.CURRENT_ACCOUNT_DETAILS.accountType === "broker";
    },
    recentActivities() {
      return this.GET_CLIENT_ACTIVITY;
    },
    titleText() {
      return this.isBroker ? this.$t("dashboard.clientActivities.cardTitleFor") : this.$t("dashboard.clientActivities.cardTitle");
    },
    currentUsername() {
      return this.CURRENT_USER_USERNAME;
    }
  }),
  watch: {
    async selectedAgentUsername(agentUsername) {
      this.loading = true;
      this.offset = 0;
      this.shouldFetchMore = true;
      await this.loadActivities();
      this.loading = false;
      Amplitude.logEvent("Dashboard - client activity agent changed", {
        page: "dashboard",
        subpage: "client-activity",
        data: {
          agentUsername
        }
      });
    }
  },
  mounted() {
    this.selectedAgentUsername = this.currentUsername;
    this.loadActivities();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DashboardStore", [LOAD_CLIENT_ACTIVITY])), {}, {
    buttonText(type) {
      const map = {
        "new-client-signup": "",
        "document-uploaded": this.$tc("dashboard.viewDocument", 1),
        "requested-documents": this.$tc("dashboard.viewDocument", 2),
        "marked-document-complete": this.$tc("dashboard.viewDocument", 1),
        "marked-document-outstanding": this.$tc("dashboard.viewDocument", 1),
        "application-changed": this.$t("dashboard.clientActivities.seeApplication"),
        "application-submitted": this.$t("dashboard.clientActivities.seeApplication"),
        "comment-added-to-document": this.$tc("dashboard.viewDocument", 2),
        "reminder-added": this.$t("dashboard.clientActivities.viewNote"),
        "broker-import-completed": this.$t("global.actions.viewResults")
      };
      return map[type];
    },
    async loadActivities() {
      if (!this.shouldFetchMore || this.loadingClients) return;
      this.loadingClients = true;
      this.shouldFetchMore = await this.LOAD_CLIENT_ACTIVITY({
        agentUsername: this.selectedAgentUsername,
        loadAll: this.selectedAgentUsername === "",
        offset: this.offset,
        limit: this.limit
      });
      this.offset += this.limit;
      this.loading = false;
      this.loadingClients = false;
    },
    onScrollBottom({
      target: {
        scrollTop,
        clientHeight,
        scrollHeight
      }
    }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.loadActivities();
      }
    },
    async downloadFile(event) {
      var _result;
      let result;
      switch (event.type) {
        case "broker-import-completed":
          result = await getBrokerImportReportAsCSV(event.id);
          break;
      }
      window.open((_result = result) == null ? void 0 : _result.url, "_blank");
      Amplitude.logEvent("Dashboard - client activity data entry downloaded as csv", {
        page: "dashboard",
        subpage: event.type
      });
    }
  })
});